import dayjs from 'dayjs';

import { useIntl } from '@kamernet/core/Intl';

export const useFormatDateRange = () => {
  const { T } = useIntl();

  const formatDateRange = (
    startDate: string,
    endDate?: string | null,
  ): string => {
    // eslint-disable-next-line custom/no-restricted-dayjs
    const start = dayjs(startDate);

    if (!endDate) {
      return T('LBL_FROM_DATE', start.format('D MMM YYYY'));
    }

    // eslint-disable-next-line custom/no-restricted-dayjs
    const end = dayjs(endDate);

    if (start.year() === end.year()) {
      if (start.month() === end.month()) {
        return `${start.format('D')} - ${end.format('D MMM YYYY')}`;
      }
      return `${start.format('D MMM')} - ${end.format('D MMM YYYY')}`;
    }

    return `${start.format('D MMM YYYY')} - ${end.format('D MMM YYYY')}`;
  };

  return formatDateRange;
};
